import { combineReducers } from 'redux';
import filters from './filters';
import statistics from './statistics';
import mentions from './mentions';

export default combineReducers({ filters, statistics, mentions });